<div class="page-holder">

  <div class="title-holder">
    <div class="center-content">

      <div class="top-element-holder">

        <div class="text-holder  top">
          <h2 class="title uppercase left">ZGrani Nagradzani</h2>
          <div class="lead-text" [innerHTML]="$safeNavigationMigration(page?.lead)"></div>
          <div class="acordion-holder">
            <div class="item" [class.open]="isAccordionOpen(0)">
              <div class="header" (click)="toggleAccordion(0)">
                <span>Jak zbierać punkty</span>
                <mat-icon>{{ isAccordionOpen(0) ? 'expand_less' : 'expand_more' }}</mat-icon>
              </div>
              <div class="content" [class.open]="isAccordionOpen(0)">
                <div class="content-inner">
                  <ul>
                    <li>Użyj tradycyjnej Karty Zgranego Grona albo zainstaluj w telefonie aplikację pozwalającą na wygenerowanie Twojego kodu QR.</li>
                    <li>Skanuj u wybranych Partnerów kod z karty bądź aplikacji. Listę aktualnych partnerów biorących udział w akcji znajdziesz poniżej.</li>
                    <li>Punkty są już na Twoim koncie — możesz je sprawdzić w swoim profilu w aplikacji bądź na stronie.</li>
                    <li>Wymieniaj punkty na wybrane nagrody z naszego katalogu.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="item" [class.open]="isAccordionOpen(1)">
              <div class="header" (click)="toggleAccordion(1)">
                <span>Za co otrzymuje się punkty</span>
                <mat-icon>{{ isAccordionOpen(1) ? 'expand_less' : 'expand_more' }}</mat-icon>
              </div>
              <div class="content" [class.open]="isAccordionOpen(1)">
                <div class="content-inner">
                  <ul>
                    <li>100 punktów na powitanie w programie</li>
                    <li>25 punktów - jednorazowa transakcja u Partnerów Programu</li>
                    <li>500 punktów na urodziny rodzica i dziecka</li>
                    <li>na eventach i wydarzeniach ZGranego Grona</li>
                    <li>w zabawach i konkursach na facebooku</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="item" [class.open]="isAccordionOpen(2)">
              <div class="header" (click)="toggleAccordion(2)">
                <span>Jak odbierać nagrody</span>
                <mat-icon>{{ isAccordionOpen(2) ? 'expand_less' : 'expand_more' }}</mat-icon>
              </div>
              <div class="content" [class.open]="isAccordionOpen(2)">
                <div class="content-inner">
                  Stan punktów sprawdzisz w aplikacji oraz po zalogowaniu się na swoje konto w www.zgranegrono.pl.
                  Wybierz nagrodę odpowiadającą ilości posiadanych punktów,
                  przygotuj swoją Kartę ZGrane Grono tradycyjną lub w aplikacji oraz dowód osobisty,
                  odwiedź biuro Programu w Ratuszu, po zeskanowaniu Twojej karty wydamy Ci Nagrodę i odejmiemy z konta
                  jej równowartość w punktach !!!
                </div>
              </div>
            </div>
            <div class="item" [class.open]="isAccordionOpen(3)">
              <div class="header" (click)="toggleAccordion(3)">
                <span>Lista partnerów biorących udział w programie lojalnościowym</span>
                <mat-icon>{{ isAccordionOpen(3) ? 'expand_less' : 'expand_more' }}</mat-icon>
              </div>
              <div class="content" [class.open]="isAccordionOpen(3)">
                <div class="content-inner" [innerHTML]="$safeNavigationMigration(page?.content)"></div>
              </div>
            </div>

          </div>
        </div>
        <div class="image-holder top">
          <img src="/assets/images/awards_top.png" alt="Zgrani Nagradzani">
        </div>
      </div>

    </div>
  </div>
  <div class="statistics-holder">
    <div class="center-content">


      <div class="slider-holder">
        <div class="score-filter">
          <h3>Liczba punktów</h3>
          <div class="range-slider">
            <div class="range-inputs">
              <div class="range-input-group">
                <label for="minScore">Od:</label>
                <input 
                  type="range" 
                  id="minScore"
                  [(ngModel)]="scoreRangeMin" 
                  [min]="minScore" 
                  [max]="maxScore" 
                  [step]="10"
                  (input)="onScoreRangeChange()"
                  class="range-input range-input--min">
              </div>
              <div class="range-input-group">
                <label for="maxScore">Do:</label>
                <input 
                  type="range" 
                  id="maxScore"
                  [(ngModel)]="scoreRangeMax" 
                  [min]="minScore" 
                  [max]="maxScore" 
                  [step]="10"
                  (input)="onScoreRangeChange()"
                  class="range-input range-input--max">
              </div>
            </div>
            <div class="range-display">
              <span class="range-value">{{ formatScore(scoreRangeMin) }}</span>
              <span class="range-separator">-</span>
              <span class="range-value">{{ formatScore(scoreRangeMax) }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="page-container">
        @if (false) {
        <!-- Global points box (partner_id === 0 = total across all partners) -->
        <div class="awards-section awards-section--global-points">
          <h3 class="awards-section__title">
            <mat-icon>emoji_events</mat-icon> Twoje ZGrane punkty
          </h3>
          @if (personsLoading) {
          <mat-progress-spinner diameter="28"></mat-progress-spinner>
          }
          @if (!personsLoading) {
          @for (person of getPersonsWithGlobalPoints(); track person) {
          <div class="global-points-card">
            <div class="global-points-card__name">
              <mat-icon>person</mat-icon>
              {{ person.name }} {{ person.surname }}
            </div>
            @if (getGlobalAggregation(person); as agg) {
            <div class="global-points-card__stats">
              @if (agg.aggregation_score) {
              <div class="global-points-stat global-points-stat--score">
                <mat-icon>star</mat-icon>
                <span class="global-points-stat__value">{{ agg.aggregation_score | number }}</span>
                <span class="global-points-stat__label">punktów</span>
              </div>
              }
              @if (agg.aggregation_transactions) {
              <div class="global-points-stat global-points-stat--transactions">
                <mat-icon>point_of_sale</mat-icon>
                <span class="global-points-stat__value">{{ agg.aggregation_transactions }}</span>
                <span class="global-points-stat__label">transakcji</span>
              </div>
              }
              @if (agg.aggregation_entries) {
              <div class="global-points-stat global-points-stat--entries">
                <mat-icon>how_to_reg</mat-icon>
                <span class="global-points-stat__value">{{ agg.aggregation_entries }}</span>
                <span class="global-points-stat__label">wejść</span>
              </div>
              }
            </div>
            }


            <!-- Per-partner breakdown (partner_id > 0) -->
            @if (getPartnerAggregations(person).length > 0) {
            <div class="partner-breakdown">
              @for (pa of getPartnerAggregations(person); track pa) {
              <div class="partner-breakdown__row">
                <span class="partner-breakdown__id">
                  <mat-icon>store</mat-icon> Partner #{{ pa.partner_id }}
                </span>
                <div class="partner-breakdown__stats">
                  @if (pa.aggregation_score) {
                  <span class="partner-breakdown__stat">
                    <mat-icon>star</mat-icon>{{ pa.aggregation_score | number }} pkt
                  </span>
                  }
                  @if (pa.aggregation_amount) {
                  <span class="partner-breakdown__stat">
                    <mat-icon>payments</mat-icon>{{ pa.aggregation_amount | number:'1.2-2' }} zł
                  </span>
                  }
                  @if (pa.aggregation_transactions) {
                  <span class="partner-breakdown__stat">
                    <mat-icon>point_of_sale</mat-icon>{{ pa.aggregation_transactions }} trans.
                  </span>
                  }
                  @if (pa.aggregation_entries) {
                  <span class="partner-breakdown__stat">
                    <mat-icon>how_to_reg</mat-icon>{{ pa.aggregation_entries }} wejść
                  </span>
                  }
                </div>
              </div>
              }
            </div>
            }
          </div>
          }
          }
          @if (getPersonsWithGlobalPoints().length === 0) {
          <div class="awards-no-points">
            <mat-icon class="awards-no-points__icon">emoji_events</mat-icon>
            <p class="awards-no-points__title">Nie masz jeszcze żadnych punktów</p>
            <p class="awards-no-points__desc">
              Punkty ZGrane zbierasz za każdą aktywność u naszych partnerów&nbsp;&mdash;
              rób zakupy, korzystaj z ofert, odwiedzaj lokale i rejestruj wejścia.
              Im więcej działasz, tym więcej punktów zgromadzisz i tym cenniejsze nagrody
              możesz wybrać!
            </p>
            <ul class="awards-no-points__tips">
              <li><mat-icon>point_of_sale</mat-icon> Zarejestruj transakcję u partnera</li>
              <li><mat-icon>how_to_reg</mat-icon> Odwiedź lokal i zarejestruj wejście</li>
              <li><mat-icon>card_giftcard</mat-icon> Wymieniaj punkty na nagrody</li>
              <li><mat-icon>storefront</mat-icon> Przeglądaj oferty partnerów i korzystaj z&nbsp;promocji</li>
            </ul>
          </div>
          }


          <h3 class="awards-section__title">
            <mat-icon>campaign</mat-icon> Aktywne kampanie
          </h3>
          @if (campaignsLoading) {
          <mat-progress-spinner diameter="28"></mat-progress-spinner>
          }
          @if (!campaignsLoading && campaigns.length === 0) {
          <div class="awards-empty">
            Brak aktywnych kampanii.
          </div>
          }
          @for (campaign of campaigns; track campaign) {
          <div class="campaign-item">
            <span class="campaign-name">{{ campaign.name }}</span>
            <span class="campaign-description">{{ campaign.description }}</span>
            @if (campaign.valid) {
            <span class="campaign-badge campaign-badge--valid">
              <mat-icon>event</mat-icon> Ważne do: <strong>{{ campaign.valid | date:'dd.MM.yyyy' }}</strong>
            </span>
            }
          </div>
          }

        </div>
        }

        <!-- Main content -->
        @if (partner && !partnerLoading) {
        <!-- Active campaigns -->
        <!-- Rewards / partner products -->


        <div class="awards-section awards-section--products">



          @if (productsLoading) {
          <div class="awards-loading">
            <mat-progress-spinner diameter="28"></mat-progress-spinner>
          </div>
          }
          @if (!productsLoading && filteredProducts.length === 0 && products.length > 0) {
          <div class="awards-empty">
            Brak nagród w wybranym zakresie punktów. Spróbuj zmienić zakres.
          </div>
          }
          @if (!productsLoading && products.length === 0) {
          <div class="awards-empty">
            Brak dostępnych nagród.
          </div>
          }
          @if (!productsLoading && filteredProducts.length > 0) {
          <div class="partner-products-list">
            @for (product of filteredProducts; track product) {
            <app-partner-product class="partner-product-item" [product]="product">
            </app-partner-product>
            }
          </div>
          }
        </div>


        <!-- Person points for this partner -->
        @if (personsLoading || getPersonsForPartner().length > 0) {
        <div class="awards-section awards-section--persons">
          <h3 class="awards-section__title">
            <mat-icon>people</mat-icon> Punkty Twoich osób
          </h3>
          @if (personsLoading) {
          <mat-progress-spinner diameter="28"></mat-progress-spinner>
          }
          @if (!personsLoading) {
          @if (getPersonsForPartner().length === 0) {
          <div class="awards-empty">
            Brak zebranych punktów.
          </div>
          }
          @for (person of getPersonsForPartner(); track person) {
          <div class="person-points-row">
            <span class="person-points-name">{{ person.name }} {{ person.surname }}</span>
            @if (getPartnerAggregation(person); as agg) {
            @if (agg.aggregation_score) {
            <span class="person-points-stat">
              <mat-icon>star</mat-icon>{{ agg.aggregation_score }} pkt
            </span>
            }
            @if (agg.aggregation_amount) {
            <span class="person-points-stat">
              <mat-icon>payments</mat-icon>{{ agg.aggregation_amount | number:'1.2-2' }} zł
            </span>
            }
            @if (agg.aggregation_transactions) {
            <span class="person-points-stat">
              <mat-icon>point_of_sale</mat-icon>{{ agg.aggregation_transactions }} trans.
            </span>
            }
            @if (agg.aggregation_entries) {
            <span class="person-points-stat">
              <mat-icon>how_to_reg</mat-icon>{{ agg.aggregation_entries }} wejść
            </span>
            }
            }
          </div>
          }
          }
        </div>
        }
        }

      </div>
    </div>
  </div>
</div>